import { Heading, Text } from "./..";
import React from "react";

export default function ZFLOCFlip({ image, heading, description, ...props }) {
  return (
    <div
      {...props}
      className={`${props.className} relative group flex flex-col w-full`}
    >
      {/* Default Image with Heading */}
      <div
        className="relative 2xl:h-[660px] xl:h-[600px] lg:h-[580px] sm:h-[500px] md:h-[800px] rounded-[40px] bg-cover bg-no-repeat sm:bg-none sm:hidden"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 flex items-start justify-start p-10 sm:hidden">
          <Heading
            size="p"
            as="p"
            className="text-[72px] lg:text-[50px] font-normal leading-[80px] text-white-a700"
          >
            <>{heading}</>
          </Heading>
        </div>
      </div>

      {/* Hover Content */}
      <div className="absolute inset-0 flex flex-col gap-10 items-start p-10 rounded-[40px] bg-gray-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 sm:opacity-100 sm:relative">
        {/* Heading for Hover */}
        <Heading
          size="text7xl"
          as="p"
          className="text-[72px] lg:text-[50px] sm:text-[40px] font-normal leading-[80px] text-gray-950 flex-grow"
        >
          <>{heading}</>
        </Heading>

        {/* Description Text */}
        <Heading
          size="p"
          as="p"
          className="w-[90%] text-[22px] lg:text-[14px] xl:text-[18px] sm:text-[15px] font-light leading-[30px] text-gray-700 mt-auto"
        >
          {description}
        </Heading>
      </div>
    </div>
  );
}
